export { DollarSign as default } from './DollarSign';
